import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import hcPackage from "../../services/hcPackage.service";
import physioPackage from "../../services/physioPackage.service";
import AuthService from "../../services/auth.service";

export const getPhysioPackage = createAsyncThunk(
  "/package?flow=physio/get",
  async (thunkAPI) => {
    try {
      const data = await physioPackage.getPhysioPackage();
      return { user: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue({ message });
    }
  }
);

// export const postWmPackage = createAsyncThunk(
//   "wmPackage/post",
//   async (item, thunkAPI) => {
//     try {
//       const data = await wmPackageService.postWmPackage(item);
//       return { user: data };
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue({ message });
//     }
//   }
// );

// export const editWmPackage = createAsyncThunk(
//   "wmPackage/put",
//   async (item, thunkAPI) => {
//     try {
//       const data = await wmPackageService.editWmPackage(item);
//       return { user: data };
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue({ message });
//     }
//   }
// );

// export const deleteWmPackage = createAsyncThunk(
//   "wmPackage/delete",
//   async (thunkAPI) => {
//     try {
//       const data = await wmPackageService.deleteWmPackage();
//       return { user: data };
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue({ message });
//     }
//   }
// );

const initialState = {
  loading: false,
  error: "",
  user: AuthService.getUserDetails() || null,
  isLoggedIn: false,
};

const HcPackage = createSlice({
  name: "physioPackage",
  initialState,
  extraReducers: {
    [getPhysioPackage.pending]: (state) => {
      state.loading = true;
      state.error = "";
      state.isLoggedIn = false;
      state.user = null;
    },
    [getPhysioPackage.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = "";
      state.isLoggedIn = true;
      state.user = action.payload.user;
    },
    [getPhysioPackage.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      state.isLoggedIn = false;
      state.user = null;
    },

    // [postWmPackage.pending]: (state) => {
    //   state.loading = true;
    //   state.error = "";
    //   state.isLoggedIn = false;
    //   state.user = null;
    // },
    // [postWmPackage.fulfilled]: (state, action) => {
    //   state.loading = false;
    //   state.error = "";
    //   state.isLoggedIn = true;
    //   state.user = action.payload.user;
    // },
    // [postWmPackage.rejected]: (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload.message;
    //   state.isLoggedIn = false;
    //   state.user = null;
    // },

    // [editWmPackage.pending]: (state) => {
    //   state.loading = true;
    //   state.error = "";
    //   state.isLoggedIn = false;
    //   state.user = null;
    // },
    // [editWmPackage.fulfilled]: (state, action) => {
    //   state.loading = false;
    //   state.error = "";
    //   state.isLoggedIn = true;
    //   state.user = action.payload.user;
    // },
    // [editWmPackage.rejected]: (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload.message;
    //   state.isLoggedIn = false;
    //   state.user = null;
    // },

    // [deleteWmPackage.pending]: (state) => {
    //   state.loading = true;
    //   state.error = "";
    //   state.isLoggedIn = false;
    //   state.user = null;
    // },
    // [deleteWmPackage.fulfilled]: (state, action) => {
    //   state.loading = false;
    //   state.error = "";
    //   state.isLoggedIn = true;
    //   state.user = action.payload.user;
    // },
    // [deleteWmPackage.rejected]: (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload.message;
    //   state.isLoggedIn = false;
    //   state.user = null;
    // },
  },
});

const { reducer } = physioPackage;
export default reducer;
